<lib-exhibit [id]="id"></lib-exhibit>